type GlyphProps = {
  size?: number
  className?: string
}

function NavSvg({
  size = 22,
  className = '',
  children,
}: GlyphProps & { children: React.ReactNode }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      {children}
    </svg>
  )
}

/** Home — soft house */
export function NavHomeGlyph(props: GlyphProps) {
  return (
    <NavSvg {...props}>
      <path
        d="M4 10.5 12 4l8 6.5V20a1.5 1.5 0 0 1-1.5 1.5H5.5A1.5 1.5 0 0 1 4 20V10.5Z"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 21.5v-6h5v6"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </NavSvg>
  )
}

/** Games — controller */
export function NavGamesGlyph(props: GlyphProps) {
  return (
    <NavSvg {...props}>
      <path
        d="M7.5 8.5h9c2.4 0 4 1.8 3.6 4.1l-.7 4.2A2.8 2.8 0 0 1 16.6 19h-1.4c-.7 0-1.3-.4-1.6-1l-.5-1c-.3-.6-.9-1-1.6-1h-1c-.7 0-1.3.4-1.6 1l-.5 1c-.3.6-.9 1-1.6 1H7.4a2.8 2.8 0 0 1-2.8-2.2l-.7-4.2C3.5 10.3 5.1 8.5 7.5 8.5Z"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinejoin="round"
      />
      <path
        d="M8.2 13.2h3.2M9.8 11.6v3.2"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
      <circle cx="15.2" cy="12.6" r="0.9" fill="currentColor" />
      <circle cx="17.2" cy="14.4" r="0.9" fill="currentColor" />
    </NavSvg>
  )
}

/** Football — ball */
export function NavFootballGlyph(props: GlyphProps) {
  return (
    <NavSvg {...props}>
      <circle cx="12" cy="12" r="8.2" stroke="currentColor" strokeWidth="1.7" />
      <path
        d="M12 3.8 14.6 9.2 20 10.2 15.8 14.4 17.1 20 12 17.2 6.9 20 8.2 14.4 4 10.2 9.4 9.2 12 3.8Z"
        stroke="currentColor"
        strokeWidth="1.35"
        strokeLinejoin="round"
      />
    </NavSvg>
  )
}

/** Horse — simplified horse head mark */
export function NavHorseGlyph(props: GlyphProps) {
  return (
    <NavSvg {...props}>
      <path
        d="M6.5 18.5c1.2-3.2 2-6.2 2.2-8.4.2-1.8 1.1-3.4 2.8-4.2 1.2-.6 2.7-.5 3.8.3l1.4 1.1 2.6-.4c.7-.1 1.3.5 1.1 1.2l-.6 2.2c1.2.9 1.9 2.2 2 3.7.1 1.4-.4 2.8-1.5 3.8"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.2 9.2c.8.2 1.5.8 1.8 1.6"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <circle cx="13.6" cy="10.2" r="0.85" fill="currentColor" />
    </NavSvg>
  )
}

/** Airdrop — coin drop */
export function NavAirdropGlyph(props: GlyphProps) {
  return (
    <NavSvg {...props}>
      <circle cx="12" cy="13.2" r="6.2" stroke="currentColor" strokeWidth="1.7" />
      <path
        d="M12 10.4v5.6M10.2 12.2 12 10.4l1.8 1.8"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.2 4.6h5.6"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
      <path
        d="M12 4.6V7"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
    </NavSvg>
  )
}

/** Gift — box with bow */
export function NavGiftGlyph(props: GlyphProps) {
  return (
    <NavSvg {...props}>
      <rect
        x="4.5"
        y="10"
        width="15"
        height="10.5"
        rx="2"
        stroke="currentColor"
        strokeWidth="1.7"
      />
      <path d="M4.5 14.2h15" stroke="currentColor" strokeWidth="1.7" />
      <path d="M12 10v10.5" stroke="currentColor" strokeWidth="1.7" />
      <path
        d="M12 10c-1.6-2.8-4.4-3.2-5.4-1.8C5.4 9.8 7.2 12 12 10Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M12 10c1.6-2.8 4.4-3.2 5.4-1.8C18.6 9.8 16.8 12 12 10Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </NavSvg>
  )
}

/** Profile — person */
export function NavProfileGlyph(props: GlyphProps) {
  return (
    <NavSvg {...props}>
      <circle cx="12" cy="8.2" r="3.4" stroke="currentColor" strokeWidth="1.7" />
      <path
        d="M5.2 19.2c1.2-3.4 3.6-5 6.8-5s5.6 1.6 6.8 5"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
    </NavSvg>
  )
}
